import { Link } from '@nimbus-ds/components';
import { ExclamationTriangleIcon } from '@nimbus-ds/icons';
import { EmptyMessage } from '@nimbus-ds/patterns';
import useTranslationShipping from 'domains/Shipping/useTranslationShipping';

interface LocationDetailsErrorProps {
  onRetryError: () => void;
}

function LocationDetailsError({
  onRetryError,
}: LocationDetailsErrorProps): JSX.Element {
  const t = useTranslationShipping();

  return (
    <EmptyMessage
      title={t('locations.form.edit.errorOnLoad')}
      icon={
        <ExclamationTriangleIcon
          size={32}
          style={{
            marginTop: '3rem',
          }}
        />
      }
      actions={
        <Link appearance="neutral" onClick={onRetryError}>
          {`${t('locations.form.edit.retry')}`}
        </Link>
      }
    />
  );
}

export default LocationDetailsError;
